import { render, staticRenderFns } from "./PRO_ByPatientType.vue?vue&type=template&id=e8177ab2&scoped=true&"
import script from "./PRO_ByPatientType.vue?vue&type=script&lang=js&"
export * from "./PRO_ByPatientType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8177ab2",
  null
  
)

export default component.exports